export default __webpack_public_path__ + "static/patterns-54891628a8290bba2cc7d1722571b39c.webp";